import React, { createContext, useContext } from 'react'
import { createConsumer } from '@rails/actioncable'

const CableContext = createContext()

export const useCableContext = () => useContext(CableContext)

export const CableProvider = ({ children }) => {
  const actionCableUrl =
    window['__APP_CONFIG__']?.actionCableUrl || process?.env?.ACTIONCABLE_URL

  const CableApp = {}
  CableApp.cable = createConsumer(actionCableUrl)

  return (
    <CableContext.Provider value={CableApp}>{children}</CableContext.Provider>
  )
}
